export const DOMAINS_SEARCH_GATE_TRANSLATIONS_NS = 'domains-search-gate-translations-ns';
export const resourceLoader = async locale => {
  return import(`./locale/messages_${locale}.json`);
};
//# sourceMappingURL=resourceLoader.js.map